// src/features/analytics/useAnalyticsRange.ts

import { useMemo } from 'react';
import { analyticsRouteApi } from './routeApi';
import { useAnalyticsMeta } from './useAnalyticsMeta';
import { resolveAnalyticsRange, type AnalyticsSearch } from './searchParams';
import type { UtcRange } from '@/shared/utils/utcRange';

export interface UseAnalyticsRangeResult {
  search: AnalyticsSearch;
  range: UtcRange;
  /** UTC midnight of T when configured (Phase 6); null through Phase 5. */
  productWindowFloorSeconds: number | null;
}

/**
 * Read the validated /analytics search params and resolve them to a concrete
 * end-exclusive UTC epoch-second range (product-window floor applied).
 */
export function useAnalyticsRange(): UseAnalyticsRangeResult {
  const search = analyticsRouteApi.useSearch();
  const { productWindowFloorSeconds } = useAnalyticsMeta();

  const range = useMemo(
    () =>
      resolveAnalyticsRange(
        search,
        Math.floor(Date.now() / 1000),
        productWindowFloorSeconds
      ),
    [search, productWindowFloorSeconds]
  );

  return { search, range, productWindowFloorSeconds };
}
